import getGlobal from '../getGlobal';
var g = getGlobal();
export default g.cancelAnimationFrame || g.webkitCancelAnimationFrame || g.clearTimeout;